import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import React from "react";

import { CategoryPageGradeQueryQuery } from "../../../shared/generated/graphql";
import { PillsComponent } from "../categories/CategoryPills";
import PageSectionTitle from "./PageSectionTitle";
import CategoryGradeQuery from "./queries/CatgoryGradeQuery";
import { TUTORING_CATEGORY } from "./utils/tutoringConst";

export default function TutoringByGrade() {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\TutoringByGrade"
  );
  const { data: { categoryPages: grades } = {}, loading } =
    useQueryWithPreviousData<CategoryPageGradeQueryQuery>(CategoryGradeQuery);

  return (
    <>
      {!loading && grades && (
        <Box sx={{ "& [role='presentation']": { marginTop: "0" } }}>
          <PageSectionTitle title={t("Tutoring by Grade")} />
          <PillsComponent
            hasHeading={false}
            categories={grades}
            categorySlug={TUTORING_CATEGORY}
          />
        </Box>
      )}
    </>
  );
}
